import React from 'react'
import { Provider } from 'react-redux'
import { createTracker } from 'redux-segment'

import { Route } from 'react-router'
import { Switch } from 'react-router-dom'
import { ConnectedRouter, routerReducer, routerMiddleware } from 'react-router-redux'

import createHistory from 'history/createBrowserHistory'

import { createStore, applyMiddleware, combineReducers } from 'redux'

import axios from 'axios'
import thunk from 'redux-thunk'
import promise from 'redux-promise-middleware'
import injectTapEventPlugin from 'react-tap-event-plugin'
import { Helmet } from 'react-helmet'

import * as reducers from './reducers'

import Home from './containers/home'
import Login from './containers/login'
import Logout from './containers/login/Logout'
import Sites from './containers/sites'
import CombinedDataViews from './containers/combinedDataViews'
import FlatContent from './containers/flatContent'
import Site from './containers/sites/site'
import SiteConfig from './containers/sites/config'
import DefaultDataViewDashboard from './containers/dashboard/defaultDataViewDashboard'
import Menu from './containers/layout/Menu'
//import Management from './containers/management'
import ManagementIndex from './containers/management'
import ManagementSites from './containers/management/sites'
import ManagementSitesEditSelect from './containers/management/sites'
import ManagementSitesDuplicate from './containers/management/sites/duplicate'
//import SiteDuplicate from './containers/management/siteDuplicate'
//import SiteEdit from './containers/management/siteEdit'

import { setAuthInterceptor, setAuthFromLocalStorage } from './utils/authUtils'
import Environment from './utils/environment'

const logger = (process.env.NODE_ENV === 'development') ? require('redux-logger').default : false

window.analytics.load(Environment.SEGMENT)

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory()
const routing = routerMiddleware(history)

try {
  injectTapEventPlugin()
} catch (e) {}

setAuthInterceptor()
setAuthFromLocalStorage()

axios.defaults.baseURL = Environment.API_URL
axios.defaults.headers.common['Accept'] = `application/json; version=${Environment.API_VERSION}`

const tracker = createTracker()
const reducer = combineReducers({
  ...reducers,
  routing: routerReducer,
})

// define middleware
const middleware = [
  thunk,
  promise(),
  routing,
  logger,
  tracker,
].filter(m => typeof m === 'function')

// create the redux store
const store = createStore(
  reducer,
  applyMiddleware(...middleware),
)

const ScrollToTop = ({ children }) => {
  window.scrollTo(0, 0)
  return (
    <div>
      {children}
    </div>
  )
}

const HelmetRootTemplate = () => <Helmet
  titleTemplate={`%s :: ${Environment.TITLE_SITE_NAME}`}
  defaultTitle={`${Environment.TITLE_SITE_NAME}`}
  meta={[
    { property: 'og:title', content: `${Environment.TITLE_SITE_NAME}` },
    { property: 'charset', content: 'utf-8' }
  ]}
/>

const App = () => {

  return (<Provider store={store} key="provider">
    <ConnectedRouter history={history}>
        <ScrollToTop>
          <HelmetRootTemplate />
          <Menu />
          <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/sites" component={Sites} />
          <Route exact path="/sites/:company_slug/:site_slug/data_views/gauge" component={Site}/>
          <Route exact path="/sites/:company_slug/:site_slug/data_views/:data_view_slug" component={Site}/>
          <Route exact path="/sites/:company_slug/:site_slug" component={Site}/>
          <Route exact path="/sites/:company_slug/:site_slug/configure" component={SiteConfig}/>
          <Route exact path="/dashboard" component={DefaultDataViewDashboard} />
          <Route exact path="/combined_data_views/:company_slug/:data_view_slug" component={CombinedDataViews} />
          <Route exact path="/combined_data_views" component={CombinedDataViews} />
          <Route exact path="/management" component={ManagementIndex} />
          <Route exact path="/management/sites" component={ManagementSites} />
          <Route exact path="/management/sites/edit" component={ManagementSitesEditSelect} />
          <Route exact path="/management/sites/duplicate" component={ManagementSitesDuplicate} />
        </Switch>
      </ScrollToTop>
    </ConnectedRouter>
  </Provider>)
}

export default App



// WEBPACK FOOTER //
// ./src/App.js